import { render } from "./EditCarInfo.vue?vue&type=template&id=9b248388&scoped=true"
import script from "./EditCarInfo.vue?vue&type=script&lang=js"
export * from "./EditCarInfo.vue?vue&type=script&lang=js"

import "./EditCarInfo.vue?vue&type=style&index=0&id=9b248388&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b248388"]])

export default __exports__